import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bg-white"
    >
      {/* Soft gold glow */}
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-gradient-to-br from-[#B76E79]/8 to-[#D68B8B]/5 blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-8 items-center pt-24 pb-12 md:pt-20 md:pb-0">
        {/* Image - shows first on mobile */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.8, ease: "easeOut" }}
          className="order-1 md:order-2"
        >
          <div className="relative overflow-hidden aspect-[4/5] md:aspect-[4/5] gold-glow max-h-[50vh] md:max-h-none">
            <img
              src="https://images.unsplash.com/photo-1759262151080-e05ba1c6294f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=800"
              alt="Purevia Güzellik Bursa - Premium güzellik merkezi"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute bottom-0 left-0 right-0 h-1 gold-bg" />
          </div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 2, ease: "easeOut" }}
          className="order-2 md:order-1"
        >
          <p
            data-testid="hero-overline"
            className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-4 md:mb-6"
          >
            Purevia Güzellik Bursa
          </p>
          <h1
            data-testid="hero-headline"
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.1] text-black mb-4 md:mb-6"
          >
            Bursa'da Güzelliğin
            <br />
            <span className="gold-text">Yeni Standardı</span>
          </h1>
          <p
            data-testid="hero-subheadline"
            className="text-sm md:text-base lg:text-lg font-normal leading-relaxed text-black/70 mb-8 md:mb-10 max-w-md"
          >
            Uzman dokunuşlarla estetik, bakım ve rahatlama bir arada.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="https://wa.me/905441199544"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-randevu"
              className="inline-flex items-center justify-center bg-black text-white hover:bg-gray-900 transition-colors duration-300 px-6 sm:px-8 py-3.5 sm:py-4 uppercase tracking-widest text-xs sm:text-sm font-semibold"
            >
              Randevu Al
            </a>
            <a
              href="https://wa.me/905441199544?text=Merhaba%2C%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center justify-center border border-black text-black hover:bg-black hover:text-white transition-colors duration-300 px-6 sm:px-8 py-3.5 sm:py-4 uppercase tracking-widest text-xs sm:text-sm font-semibold"
            >
              WhatsApp'tan Yaz
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
